import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ExpenditureIncomeReportComponent } from '../expenditure-income-report/expenditure-income-report.component';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-deposit-slip-report',
  templateUrl: './deposit-slip-report.component.html',
  styleUrl: './deposit-slip-report.component.scss'
})
export class DepositSlipReportComponent {

  mainexp: any;
  subexp: any;
  startDate: any;
  endDate: any;
  allvoucherdata: any;
  dr_opening_bal: any;
  currentDate: Date;
  exp_name: any;
  cr_opening_bal: any;
  credittotal: any;
  debittotal: any;

  categories = [
    { name: 'Assent', expenses: [], expanded: true },
    { name: 'Liabilities', expenses: [], expanded: true },
    { name: 'Income', expenses: [], expanded: true },
    { name: 'Expenditure', expenses: [], expanded: true }
  ];

  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<DepositSlipReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
  ) {

  }

  getFormattedDate(): string {
    return this.datePipe.transform(this.currentDate, 'dd-MM-yyyy');
  }

  toggleCategory(category: any) {
    category.expanded = !category.expanded;
  }

  ngOnInit(): void {
    this.currentDate = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.mainexp = this.data['mainexp'];
    this.subexp = this.data['subexp'];
    this.getDepositSlipAccountReport()
    this.categories.forEach(category => {
      category.expanded = true;
    });
  }

  getDepositSlipAccountReport() {
    const cv: any = {
      "startdate": this.startDate,
      "enddate": this.endDate
    }

    // this.service.getDepositSlipAccountReport(cv).subscribe((response) => {
    //   this.allvoucherdata = response;
    //   this.processExpenses();
    // });

    this.service.getDepositSlipAccountReport(cv).pipe(
      catchError(err => {
        console.error('Error in getDepositSlipAccountReport', err);
        return of([]); // Continue with empty data
      }),
      switchMap((response1: any[]) => {
        this.allvoucherdata = response1 || [];

        const req1 = {
          start_date: this.startDate,
          end_date: this.endDate,
          advt_name: ''
        };

        return this.service.getPersoanlLedBriefly(req1).pipe(
          catchError(err => {
            console.error('Error in getPersoanlLedBriefly', err);
            return of([]);
          }),
          map(res => {
            const advtReceivedAmt = Array.isArray((res as any).data)
              ? (res as any).data
                .filter((item: any) => parseFloat(item.received_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'जाहिरातदार / देणगीदार खाते',
                  sub_exp_name: item.advt_name,
                  final_amt: (parseFloat(item.received_amt) * -1),
                  exp_type: 'Assent'
                }))
              : [];
            this.allvoucherdata = this.allvoucherdata.concat(advtReceivedAmt);
          })
        );
      }),
      switchMap(() => {
        const cvv = {
          startDate: this.startDate,
          endDate: this.endDate,
          issue_seller_name: ''
        };
        return this.service.getIssuePersoanlLedBriefly(cvv).pipe(
          catchError(err => {
            console.error('Error in getIssuePersoanlLedBriefly', err);
            return of([]);
          }),
          map(res => {
            const issueSellerReceivedAmt = Array.isArray(res)
              ? res.filter((item: any) => parseFloat(item.rcv_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'अंक विक्री / प्रतिनिधि मुख्य खाते',
                  sub_exp_name: item.issue_seller_name,
                  final_amt: (parseFloat(item.rcv_amt) * -1),
                  exp_type: 'Assent'
                }))
              : [];

            this.allvoucherdata = this.allvoucherdata.concat(issueSellerReceivedAmt);
          })
        );
      }),
      switchMap(() => {
        const req = {
          start_date: this.startDate,
          end_date: this.endDate,
          book_seller_name: ''
        };
        return this.service.getBookSellerLedgerBriefly(req).pipe(
          catchError(err => {
            console.error('Error in getBookSellerLedgerBriefly', err);
            return of([]);
          }),
          map(res => {
            const bookSellerReceivedAmt = Array.isArray(res)
              ? res
                .filter((item: any) => Number(item?.rcv_amt) > 0)
                .map((item: any) => ({
                  exp_name: 'पुस्तक प्रलंबित देय रक्कम',
                  sub_exp_name: item.book_seller_name || '',
                  final_amt: (parseFloat(item.rcv_amt) * -1),
                  exp_type: 'Assent'
                }))
              : [];

            // ✅ remove old book-seller entries only
            this.allvoucherdata = this.allvoucherdata.filter(
              d => d.exp_name !== 'पुस्तक प्रलंबित देय रक्कम'
            );

            // ✅ now safely append fresh book-seller data
            this.allvoucherdata = [...this.allvoucherdata, ...bookSellerReceivedAmt];

            return bookSellerReceivedAmt;
          })
        );
      })
    ).subscribe({
      next: () => {
        this.processExpenses(); // Final call
      },
      error: (err) => {
        console.error('Unexpected error', err);
      }
    });
  }

  expenseMap: Map<string, { expenses: any[], total_final_amt: number }> = new Map();
  expenseArray: { exp_name: string, expenses: any[], total_final_amt: number }[] = [];

  // 

  processExpenses() {
    this.expenseMap = new Map<string, { expenses: any[]; total_final_amt: number }>();

    // Check if data is empty or invalid
    if (!this.allvoucherdata || this.allvoucherdata.length === 0) {
      this.expenseArray = []; // Handle empty data case
      return;
    }

    // Filter the data for valid items and process categories
    this.allvoucherdata
      .filter(item => item.exp_name && item.exp_type && item.final_amt)
      .forEach(item => {
        const category = this.categories.find(cat => cat.name === item.exp_type);
        if (category) {
          // Ensure the final_amt is treated as a valid number
          const amount = parseFloat(item.final_amt);
          if (!isNaN(amount)) {
            item.final_amt = amount; // Correct any non-number final_amt
            category.expenses.push(item);
          } else {
            console.warn('Invalid amount:', item.final_amt, 'for expense:', item.exp_name);
          }
        }
      });

    // Aggregate expenses by category and expense name
    this.categories.forEach(category => {
      category.expenses = category.expenses.reduce((acc, current) => {
        const existingGroup = acc.find(group => group.exp_name === current.exp_name);

        const amount = current.final_amt;

        // If the amount is valid, aggregate it
        if (existingGroup) {
          existingGroup.total_final_amt += amount;
          existingGroup.expenses.push(current);
        } else {
          acc.push({ exp_name: current.exp_name, total_final_amt: amount, expenses: [current] });
        }
        return acc;
      }, []);

      const customAssentOrder = [
        'रोख खाते', 'बँक ऑफ महाराष्ट्र - 20109800154', 'TJSB सहकारी बँक लि.- 902', 'ठाणे जनता सह बँक - पुस्तक विभाग',
        'ठाणे जनता सहकारी बँक - ओडी 111', 'जनता सहकारी बँक लि, CC - 5039', 'जनता सह बँक लि, - कर्वेरोड शाखा',
        'जनता सह बँक लि - लातूर शाखा', 'जनता सह बँक लि , औरंगाबाद शाखा', 'जनकल्याण सहकारी बँक - OD - 1706',
        'बँक ऑफ महाराष्ट्र - रिकरिंग खाते', 'बँक ऑफ महाराष्ट्र - पर्यटन विभाग', 'TJSB - शिल्पकार चरित्रकोश', 'TJSB - EVIVEK.COM',
        'TJSB - संवर्धन निधी खाते', 'बँक ऑफ महाराष्ट्र - संवाद',
        'गुंतवणूक खाते', 'स्थावर मालमत्ता', 'सुरक्षित अनामत', 'टपाल अनामत',
        'बँक मुदत ठेवी व्याज येणे बाकी', 'मुदत ठेवी बँक व्याज येणे बाकी - विवेक', 'इतर संस्थामधून येणे बाकी',
        'अंतिम स्टॉक', 'नफा तोटा - 31/03/2024 ताळेबंद', 'टी डी एस 2023-24', 'टी डी एस 2024-25',
        'अंक विक्री / प्रतिनिधि मुख्य खाते', 'पुस्तक प्रलंबित देय रक्कम', 'जाहिरातदार / देणगीदार खाते',
        'मुदत ठेव (विश्वस्थ विकास निधी)', 'मुदत ठेव (विवेक साप्ताहिक)', 'ग्राहक खाते'
      ];

      const customLiabilitiesOrder = [
        'राखीव व इतर निधी', 'सिद्धी ऑफसेट प्रा लि - अनामत', 'विलायती राम मित्तल', 'अभिकर्ता अनामत',
        'असुरक्षित कर्ज (बिन व्याजी)', 'असुरक्षित कर्ज (व्याजी)', 'पुस्तक विक्री - Pending', 'अंक विक्री - Pending',
        'जाहिरात विभाग - Pending', 'वर्गणी विभाग - Pending', 'सस्पेन्स खाते', 'तात्पुरते कर्ज - Temporary Loan',
        'अनामत', 'उचल खाते', 'आयकर खाते', 'वैद्यराज व्हीजन', 'हिन्दी विवेक', 'टी.डी.एस खाते',
        'GST खरेदी (PURCHASE)', '2024-25 साठी आगाऊ वर्गणी जमा', '2024-25 साथी आगाऊ खर्चाची तरतूद',
        'ग्रंथ आगाऊ जमा', 'पुरवठादार देणी', 'SGST - जाहीरात', 'IGST - जाहिरात', 'CGST - जाहिरात',
        'ROUND UP (GST)'
      ];

      const customIncomeOrder = [
        'अंक विक्री', 'किरकोळ अंक विक्री', 'जाहिरात खाते', 'देणगी', 'पुस्तक व ग्रंथ विक्री खाते',
        'ONLINE अंक', 'वार्षिक', 'त्रैवार्षिक', 'पंचवार्षिक', 'कृषी विवेक वर्गणी',
        'हिंदुत्व', 'शताब्दी ग्रंथयात्री', 'राष्ट्रोत्थान 2100', 'राष्ट्रोत्थान 2500', 'हिंदुत्व ग्रंथ मराठी', 'रा स्व ग्रंथ - मराठी आवृत्ती',
        'रा स्व ग्रंथ - हिंदी आवृत्ती', 'राष्ट्रोस्थान मराठी ग्रंथ', 'राष्ट्रोस्थान हिन्दी ग्रंथ',
        'Magazine Post - वर्गणी', 'Magazine Post - ग्रंथ', 'कार्यालय भाडे', 'लाभांश खाते',
        'व्याज जमा खाते', 'अंतिम स्टॉक'
      ];

      const customExpenditureOrder = [
        'खरेदी खाते', 'पगार खाते', 'व्याज खाते', 'वर्तन खाते', 'वितरण खर्च खाते',
        'छपाई व स्टेशनरी खर्च', 'दुरूस्ती व देखभाल खाते', 'प्रवास खर्च', 'वाहन भाडे खाते',
        'वीज खर्च खाते', 'टेलिफोन खर्च खाते', 'लेखक मानधन खाते', 'हिशोब तपासणी फी खाते',
        'टपाल खर्च खाते', 'विमा खाते', 'कर्मचारी कल्याण खाते', 'बांधणी खर्च खाते',
        'कार्यालीन खर्च खाते', 'जाहिरात टी डी एस', 'भाडे खर्च खाते', 'बैठक खर्च',
        'मुद्रित शोधन खाते', 'व्यवसाय शुल्क (Professional Fees)', 'बँक कमिशन खाते',
        'चित्रे सजावट', 'वर्तमान पत्रे व नियतकालिके', 'कार्यक्रम खर्च खाते', 'पुस्तक खरेदी खाते',
        'संगणक दुरुस्ती व देखभाल', 'भाषांतर चार्जेस', 'व्यवसाय कर', 'मालमत्ता कर',
        'जाहिरात क्रेडिट नोट', 'पुस्तक विक्री क्रेडिट नोट', 'अंक विक्री क्रेडिट नोट',
        'संगणक प्रणाली', 'प्रवास भत्ता ( कर्मचारी )', 'पगार नियंत्रण', 'हिशेब तपासणी फी',
        'प्रारंभीचा स्टॉक'
      ];

      let customOrder: string[] = [];
      switch (category.name) {
        case 'Income':
          customOrder = customIncomeOrder;
          break;
        case 'Expenditure':
          customOrder = customExpenditureOrder;
          break;
        case 'Assent':
          customOrder = customAssentOrder;
          break;
        case 'Liabilities':
          customOrder = customLiabilitiesOrder;
          break;
      }

      // 🔽 Perform custom sort using index + fallback Marathi alphabetical
      category.expenses.sort((a, b) => {
        const indexA = customOrder.indexOf(a.exp_name);
        const indexB = customOrder.indexOf(b.exp_name);

        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        return a.exp_name.localeCompare(b.exp_name, 'mr'); // Marathi fallback
      });
    });
  }

  getDebitTotal(): number {
    return this.categories.reduce((total, category) => {
      return total + category.expenses.reduce((sum, group) => {
        if ((group.expenses[0].exp_type === 'Expenditure' || group.expenses[0].exp_type === 'Assent') && group.total_final_amt < 0) {
          return sum + group.total_final_amt;
        }
        if ((group.expenses[0].exp_type === 'Liabilities' || group.expenses[0].exp_type === 'Income') && group.total_final_amt < 0) {
          return sum + group.total_final_amt;
        }
        debugger
        return sum;
      }, 0);
    }, 0);
  }

  getCreditTotal(): number {
    return this.categories.reduce((total, category) => {
      return total + category.expenses.reduce((sum, group) => {
        if ((group.expenses[0].exp_type === 'Liabilities' || group.expenses[0].exp_type === 'Income') && group.total_final_amt > 0) {
          return sum + group.total_final_amt;
        }
        if ((group.expenses[0].exp_type === 'Expenditure' || group.expenses[0].exp_type === 'Assent') && group.total_final_amt > 0) {
          return sum + group.total_final_amt;
        }
        debugger
        return sum;
      }, 0);
    }, 0);
  }

  exportExcel(fileName: string): void {

    const excelData: any[] = [];

    // Loop categories
    this.categories.forEach((category: any) => {

      // Category row
      excelData.push({
        'तपशील': category.name,
        'मुख्य खाते': '',
        'ऊप खाते': '',
        'ऊप खाते बॅलन्स': '',
        'डेबिट': '',
        'क्रेडिट': ''
      });

      category.expenses.forEach((group: any) => {

        const expType = group.expenses?.[0]?.exp_type;
        const amt = Number(group.total_final_amt || 0);

        let debit: any = '';
        let credit: any = '';

        if (expType === 'Assent' || expType === 'Expenditure') {
          if (amt >= 0) {
            debit = Math.abs(amt).toFixed(2);
          } else {
            credit = Math.abs(amt).toFixed(2);
          }
        }

        if (expType === 'Liabilities' || expType === 'Income') {
          if (amt >= 0) {
            credit = Math.abs(amt).toFixed(2);
          } else {
            debit = Math.abs(amt).toFixed(2);
          }
        }

        // Group row (Main Account)
        excelData.push({
          'तपशील': '',
          'मुख्य खाते': group.exp_name,
          'ऊप खाते': '',
          'ऊप खाते बॅलन्स': '',
          'डेबिट': debit,
          'क्रेडिट': credit
        });

        // Sub-expenses
        if (group.expenses?.length > 1) {
          group.expenses.forEach((item: any) => {
            excelData.push({
              'तपशील': '',
              'मुख्य खाते': '',
              'ऊप खाते': item.sub_exp_name,
              'ऊप खाते बॅलन्स': Number(item.final_amt || 0).toFixed(2),
              'डेबिट': '',
              'क्रेडिट': ''
            });
          });
        }

      });
    });

    // Total row
    excelData.push({
      'तपशील': '',
      'मुख्य खाते': 'एकूण (TOTAL)',
      'ऊप खाते': '',
      'ऊप खाते बॅलन्स': '',
      'डेबिट': Math.abs(this.getDebitTotal()).toFixed(2),
      'क्रेडिट': Math.abs(this.getCreditTotal()).toFixed(2)
    });

    // Excel creation
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Trial Balance': worksheet },
      SheetNames: ['Trial Balance']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    saveAs(blob, `${fileName}_${Date.now()}.xlsx`);
  }

}